import React, { useContext } from "react";
import VideoItemTransition from "./VideoGroupItem/VideoItemTransition/VideoItemTransition";
import { IMaterialFile, ISences } from "@/stores/mixCutDetailStore/type";
import { mixCutDetailContext } from "../../index";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import useMixCutDetail from "@/useStore/mixCutDetail/useMixCutDetail";
import useCaption from "@/useStore/mixCutDetail/useCaption";
import useTitle from "@/useStore/mixCutDetail/useTitle";
import { observer } from "mobx-react";
import useTransition from "@/useStore/mixCutDetail/useTransition";
import VideoGroupItem from "./VideoGroupItem/VideoGroupItem";
import usePreviewConfig from "@/useStore/preview/usePreview";
import usePreviewInfo from "@/useStore/mixCutDetail/usePreviewInfo";
import _ from "lodash";
import mixCutDetailStore from "@/stores/mixCutDetailStore";
import QuickStore from "@/stores/quickCutStore";
export interface IVideoGroupBlockProps {
  data: any;
  handleDataChange: (data: any) => void;
  handleVideoGroupDelete: (index: number) => void;
  handleTransitionBtnClick: (index: number) => void;
  handleProjectVideoChange: (index: number, data: IMaterialFile[]) => void;
  handleUploadBtnClick: (type: "material" | "local", index: number) => void;
  handleMetarialEditBtnClick: (groupIndex: number, index: number) => void;
  // handlePlayerCaption: (index: number) => void;
  // handlePlayerCaptionStop: (index: number) => void;
  handleHeaderItemClick: (index: number | string) => void;
  toGetText?: (id: string) => void;
  onTextAnalysis?: (data: object) => void;
  handleTextAnalysis?: (id: string) => void;
  videoStatusList: any;
}

const VideoGroupBlock: React.FC<IVideoGroupBlockProps> = observer((props) => {
  const {
    data,
    handleDataChange,
    handleVideoGroupDelete,
    handleTransitionBtnClick,
    handleProjectVideoChange,
    handleUploadBtnClick,
    handleMetarialEditBtnClick,
    handleHeaderItemClick,
    toGetText,
    onTextAnalysis,
    videoStatusList,
  } = props;
  const { toIndexGetError } = usePreviewInfo();
  const { transition } = useTransition();
  const { global } = useMixCutDetail();
  const { handleSwapCaptionItem, projectCaption } = useCaption();
  const { handelSwapTitleItem, titleList } = useTitle();
  const { transitions } = QuickStore.quickcutData;
  const {
    handlePreviewTitleChange,
    handlePreviewCaptionChange,
    handleClipIdChange,
    handleToChangeVideoIndexSetTitleAndCaption,
  } = usePreviewConfig();
  const { videoGroupActive, setVideoGroupActive } =
    useContext(mixCutDetailContext);
  const onDragEnd = (result) => {
    const { destination, source } = result;
    // 如果没有目标位置，直接返回
    if (!destination) return;
    // 如果拖拽到相同位置，直接返回
    if (destination.index === source.index) return;
    // 如果拖拽到相同位置，直接返回
    if (
      source.index === destination.index &&
      source.droppableId === destination.droppableId
    ) {
      return;
    }
    // 创建一个新的分镜列表
    const newScenes = Array.from(data);
    // 从原位置移除拖拽的分镜
    const [removedScene] = newScenes.splice(source.index, 1);
    // 将拖拽的分镜插入到目标位置
    newScenes.splice(destination.index, 0, removedScene);
    // 更新数据
    handleDataChange(newScenes);
    // 设置当前激活的视频组
    setVideoGroupActive(destination.index);
    handleClipIdChange(null);
  };
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="video-group-droppable">
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {(data || []).map((item, index) => {
              // type 为 1 或 3 的片头片尾不允许拖拽
              if (item.type === 1 || item.type === 3) {
                return (
                  <React.Fragment key={item.id}>
                    <div key={item.id}>
                      <VideoGroupItem
                        duration={item.duration}
                        type={item.type}
                        videoStatusList={videoStatusList}
                        key={item.id}
                        onClick={() => {
                          handleClipIdChange(null);
                          handleHeaderItemClick(item.id);
                        }}
                        sencesIndex={index}
                        error={toIndexGetError(index)}
                        handleEditBtnClick={(e) => {
                          handleMetarialEditBtnClick(index, e);
                        }}
                        isDragging={false}
                        active={videoGroupActive === index}
                        handleHeaderClick={() => {
                          handleClipIdChange(null);
                          handleHeaderItemClick(index);
                        }}
                        name={item?.name}
                        materials={item?.materials}
                        materialMute={item?.material_mute}
                        disabled={item?.disabled}
                        speed={item?.speed}
                        clipRule={item?.setting?.clip_rule}
                        hanldeMaterialChange={(e) => {
                          handleProjectVideoChange(index, e);
                        }}
                        handleNameChange={(e) => {
                          data[index].name = e;
                          handleDataChange([...data]);
                        }}
                        handleSetting={(key, state) => {
                          data[index][key] = state;
                          handleDataChange([...data]);
                        }}
                        handleDeleteBtnClick={() => {
                          handleVideoGroupDelete(index);
                        }}
                        handleUploadBtnClick={(type: "material" | "local") => {
                          handleUploadBtnClick(type, index);
                        }}
                        // 不传 dragHandleProps
                      />
                    </div>
                    {index !== data.length - 1 && (
                      <VideoItemTransition
                        onClick={() => {
                          handleTransitionBtnClick(index);
                          setVideoGroupActive(index + 1);
                        }}
                        number={transitions[index]?.effects?.length || 0}
                      />
                    )}
                  </React.Fragment>
                );
              }
              // 其它类型允许拖拽
              return (
                <Draggable key={item.id} draggableId={item.id} index={index}>
                  {(provided, snapshot) => (
                    <React.Fragment key={item.id}>
                      <div
                        key={item.id}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        style={{
                          ...provided.draggableProps.style,
                        }}
                      >
                        <VideoGroupItem
                          duration={item.duration}
                          type={item.type}
                          videoStatusList={videoStatusList}
                          key={item.id}
                          onClick={() => {
                            console.log(item.id, index)
                            handleClipIdChange(null);
                            handleHeaderItemClick(item.id);
                          }}
                          sencesIndex={index}
                          error={toIndexGetError(index)}
                          handleEditBtnClick={(e) => {
                            handleMetarialEditBtnClick(index, e);
                          }}
                          isDragging={snapshot.isDragging}
                          active={videoGroupActive === index}
                          handleHeaderClick={() => {
                            handleClipIdChange(null);
                            handleHeaderItemClick(index);
                          }}
                          name={item?.name}
                          materials={item?.materials}
                          materialMute={item?.material_mute}
                          disabled={item?.disabled}
                          speed={item?.speed}
                          clipRule={item?.setting?.clip_rule}
                          settings={item.settings}
                          hanldeMaterialChange={(e) => {
                            handleProjectVideoChange(index, e);
                          }}
                          handleNameChange={(e) => {
                            data[index].name = e;
                            handleDataChange([...data]);
                          }}
                          handleSetting={(key, state) => {
                            data[index][key] = state;
                            handleDataChange([...data]);
                          }}
                          handleDeleteBtnClick={() => {
                            handleVideoGroupDelete(index);
                          }}
                          handleUploadBtnClick={(
                            type: "material" | "local"
                          ) => {
                            handleUploadBtnClick(type, index);
                          }}
                          dragHandleProps={provided.dragHandleProps}
                        />
                      </div>
                      {!snapshot.isDragging && index !== data.length - 1 && (
                        <VideoItemTransition
                          onClick={() => {
                            handleTransitionBtnClick(index);
                            setVideoGroupActive(index + 1);
                          }}
                          number={transitions[index]?.effects?.length || 0}
                        />
                      )}
                    </React.Fragment>
                  )}
                </Draggable>
              );
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
});

export default VideoGroupBlock;
